import { Autocomplete, ListItemText, type TextFieldProps } from '@all-manager/design-system-v2';
import { getTopicName, useSubTopicAutocomplete } from './useSubTopicAutocomplete';
import type { SubTopicOption } from '../../types/subTopicAutocomplete.types';

type Props = Pick<TextFieldProps, 'label' | 'helperText' | 'error' | 'required' | 'autoFocus' | 'fullWidth' | 'size' | 'disabled'> & {
  value: string | null;
  onChange: (value: string | null) => void;
  excludeIds?: string[];
};

export default function SubTopicAutocomplete(props: Props) {
  const hook = useSubTopicAutocomplete({
    value: props.value,
    onChange: props.onChange,
    excludeIds: props.excludeIds,
  });

  return (
    <Autocomplete<SubTopicOption, false, false, false>
      options={hook.options}
      getOptionLabel={hook.getOptionLabel}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      filterOptions={hook.filterOptions}
      value={hook.selectedSubTopic}
      onChange={hook.handleChange}
      onInputChange={hook.handleInputChange}
      noOptionsText={hook.inputValue.length > 0 ? 'Aucun sujet trouvé' : 'Aucun sujet disponible'}
      loadingText="Recherche en cours…"
      loading={hook.isLoading}
      renderOption={(optionProps, option) => {
        const { key, ...otherOptionProps } = optionProps;
        const topicName = getTopicName(option);

        return (
          <li key={key ?? option.id} {...otherOptionProps}>
            <ListItemText
              primary={option.name}
              secondary={topicName ? `dans ${topicName}` : undefined}
            />
          </li>
        );
      }}
      label={props.label}
      helperText={props.helperText}
      error={props.error}
      required={props.required}
      autoFocus={props.autoFocus}
      fullWidth={props.fullWidth}
      size={props.size}
      disabled={props.disabled}
      placeholder="Rechercher un sujet…"
    />
  );
}
